import { toast } from '@askable/ui/core/sonner';
import { deprecatedWithRouter } from 'HOC/deprecatedWithRouter';
import _ from 'lodash';
import { useEffect } from 'react';
import { useMutation } from 'urql';

import { LoadingOverlay } from 'components/common';
import { utils } from 'lib/utils';
import { getCombinedErrorMessage } from 'utils/error_utils';

// Mutations

import { RequestToJoinTeamChangeStatus } from './data/RequestToJoinTeamChangeStatus.mutation';

function RequestJoinAction(props: any) {
  const [{ fetching: loading }, requestToJoinTeamChangeStatus] = useMutation(RequestToJoinTeamChangeStatus);

  useEffect(() => {
    const executeAction = async () => {
      const extraArguments = utils.parseQueryParams(_.get(props, 'location.search'));
      if (extraArguments && extraArguments.get('team_request_id') && extraArguments.get('request_status')) {
        const teamRequestId: any = extraArguments.get('team_request_id');
        const requestStatus: any = extraArguments.get('request_status');
        const { error } = await requestToJoinTeamChangeStatus({
          _id: teamRequestId,
          status: parseInt(requestStatus, 10),
        });
        if (error) {
          toast.error(getCombinedErrorMessage(error, 'Error updating team request'));
          props.history.replace({ pathname: '/' });
        } else {
          toast.success(`Request successfully ${parseInt(requestStatus, 10) === 1 ? 'approved' : 'refused'}`);
          props.history.replace({ pathname: '/settings/team' });
        }
      }
    };
    void executeAction();
  }, []);

  if (loading) return <LoadingOverlay />;
  return null;
}

export default deprecatedWithRouter(RequestJoinAction);
